module.exports = __webpack_public_path__ + "static/ZURI_2_0_intro-367c37fb82b88d0c24f96d7b931f4c1d.mp4";